enum PropertyKeys {
  PRIVATE_API_KEY = 'UFJJVkFURV9BUElfS0VZ',
  PRIVATE_BASE_URL = 'UFJJVkFURV9CQVNFX1VSTA==',
}

export default PropertyKeys;
